import React, { useContext } from 'react';
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { Context } from "../../../index";
import Form from 'react-bootstrap/Form';
import {observer} from "mobx-react-lite";
import swal from "sweetalert";
import {EXAMPLE_CATEGORIES} from "../../../utils/const";

const ModalCreateAndUpdateNews = observer(({ show, onHide, type }) => {
    const { posts } = useContext(Context);

    return (
        <Modal show={show} onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>{type === 'create' ? 'Создание примера работ' : 'Изменение примера работ'}</Modal.Title>
            </Modal.Header>
            <form onSubmit={async (event) => {
                event.preventDefault();
                switch (type) {
                    case 'create':
                        if (await posts.createPost()) {
                            swal("Успешно создано", "Пример работ успешно создан", "success");
                            onHide();
                        } else {
                            swal("Ошибка!", posts.errorMessage, "error");
                        }
                        break;
                    case 'update':
                        if (await posts.updatePost()) {
                            swal("Успешно отредактировано", "Пример работ успешно изменён", "success");
                            onHide();
                        } else {
                            swal("Ошибка!", posts.errorMessage, "error");
                        }
                        break;
                    default:
                        break;
                }
            }}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Заголовок</Form.Label>
                        <Form.Control type="name" placeholder="Заголовок" value={posts.currentHeader} onChange={(e) => posts.setCurrentHeader(e.target.value)}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Категория</Form.Label>
                        <Form.Select value={posts.currentCategory} onChange={(e) => posts.setCurrentCategory(e.target.value)}>
                            {EXAMPLE_CATEGORIES.map((category) => (
                                <option key={category} value={category}>{category}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <input type="file" className="form-control mb-2" id="image1" name='image1' />
                        <input type="file" className="form-control mb-2" id="image2" name='image2' />
                        <input type="file" className="form-control" id="image3" name='image3' />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Закрыть
                    </Button>
                    <Button variant="primary" type='submit'>
                        {type === 'create' ? 'Создать' : 'Изменить'}
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
});

export default ModalCreateAndUpdateNews;
